import React, { Component } from 'react';
import Styles from 'components/pagamento/Recurrence.module.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { CtrlType, CtrlCollection } from '@yuigoto/ctrl';
import { ControlRenderer } from 'components/renderers/ControlRenderer';
import { GetEditionDateName } from 'core/utils/EditionUtils';
import { UiActions } from 'state/actions/UiActions';

export const RECURRENCE_DISABLE_MIN = 0;
export const RECURRENCE_DISABLE_MAX = 2;

export const RECURRENCE_ENABLE_MIN = 0;
export const RECURRENCE_ENABLE_MAX = 0;

/**
 * @type {import("@yuigoto/ctrl").CtrlProps[]}
 */
const RecurrenceDisableForm = [
  {
    name: 'type',
    label: 'Selecione motivo:',
    type: CtrlType.SINGLE_OPTION,
    custom: true,
    required: true,
    requiredMessage: 'Este campo é obrigatório.',
  },
  {
    name: 'message',
    label: 'Poderia nos detalhar o motivo?',
    type: CtrlType.TEXTAREA,
    required: true,
    requiredMessage: 'Este campo é obrigatório.',
    minLength: 30,
    minLengthMessage: 'Mínimo 30 caracteres.',
    maxLength: 150,
    maxLengthMessage: 'Máximo 150 caracteres.',
    customClass: Styles['textarea'],
    rows: 2,
  },
];

const RecurrenceEnableRequest = async (subscriberId, token, onSuccess, onFailure) => {
  await ExecuteRequest(
    GlamboxEndpoints.Subscriber.enableRecurrence,
    { subscriberId },
    'PUT',
    {
      Authorization: token,
    },
    null,
    (response) => {
      const { result, statusCode } = response;

      if (statusCode === 200) {
        if (onSuccess) {
          onSuccess(result && result.message ? result.message : 'Recorrência ativada com sucesso.');
        } else {
          console.error(result);
        }
      } else {
        if (onFailure) {
          onFailure(
            result && result.message ? result.message : 'Não foi possível reativar sua recorrência.'
          );
        } else {
          console.error(result);
        }
      }
    }
  );
};

const RecurrenceDisableRequest = (data, token, onSuccess, onFailure) => {
  ExecuteRequest(
    GlamboxEndpoints.Subscriber.disableRecurrence,
    data,
    'PUT',
    {
      Authorization: token,
    },
    null,
    (response) => {
      const { result, statusCode } = response;

      if (statusCode === 200) {
        if (onSuccess) {
          onSuccess(
            result && result.message ? result.message : 'Recorrência desabilitada com sucesso.'
          );
        } else {
          console.log(result);
        }
      } else {
        if (onFailure) {
          onFailure(result && result.message ? result.message : 'Erro ao desabilitar recorrência.');
        } else {
          console.error(result);
        }
      }
    }
  );
};

const RecurrenceDisableTypeRequest = (token, onSuccess, onFailure) => {
  ExecuteRequest(
    GlamboxEndpoints.Subscriber.disableRecurrenceType,
    {},
    'GET',
    {
      Authorization: token,
    },
    null,
    (response) => {
      const { result, statusCode } = response;

      if (statusCode === 200) {
        if (onSuccess) {
          onSuccess(result);
        } else {
          console.log(onSuccess);
        }
      } else {
        if (onFailure) {
          onFailure(result);
        } else {
          console.error(result);
        }
      }
    }
  );
};

export const RecurrenceEnable = ({}) => {
  return (
    <>
      <h3 className={'text-center'}>Reativar Recorrência</h3>

      <p className={'text-center'}>
        Glamgirl, você deseja reativar a recorrência para essa assinatura?
      </p>
    </>
  );
};

export const RecurrenceDisable = ({ date }) => {
  let nextRecurrenceDate = GetEditionDateName(date, false, '/');

  return (
    <>
      {/* <h3 className={'text-center mb-2'}>Tem certeza de que deseja desativar sua renovação?</h3>

      <p className={'text-center'}>
        Lembre-se que é um meio de não esquecer de renovar sua Glambox, pois se sua assinatura ficar
        inativa por 30 dias perde todos os seus glampoints acumulados e a possibilidade de trocar
        produtos no Glamclub, os descontos na Glamshop imediatamente e muitos outros benefícios,
        além da sua caixinha tão amada.
      </p> */}

      <div className={Styles['alert']}>
        <div className={Styles['icon']}>
          <svg viewBox={'0 0 36 36'}>
            <path
              d={
                'M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z'
              }
              fill={'rgba(0, 0, 0, .5)'}
            />
          </svg>
        </div>

        <p>
          <span>AVISO:</span> Desativando sua renovação automática você perderá todos os Glampoints
          e sua joia, depois do último mês da sua assinatura! Você pode voltar a ser membro da
          comunidade GLAM novamente, mas NÃO vai manter essas vantagens que ganhou na sua jornada
          como Glamgirl! Para saber mais sobre suas conquistas <a href="/glampoints">clique aqui</a>
        </p>
      </div>
    </>
  );
};

export const RecurrenceSacInfo = ({ date }) => {
  let nextRecurrenceDate = GetEditionDateName(date, false, '/');

  return (
    <>
      <div className={Styles['alert']}>
        <div className={Styles['icon']}>
          <svg viewBox={'0 0 36 36'}>
            <path
              d={
                'M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z'
              }
              fill={'rgba(0, 0, 0, .5)'}
            />
          </svg>
        </div>
        <p className={'text-center'}>
          Ok! Sua renovação automática está desativada e sua assinatura acabará depois do ultimo mês
          do seu plano ({nextRecurrenceDate}). O Cancelamento antes desse período requer a aplicação
          de multa e, para isso, o SAC deve ser acionado. Clique no ícone "ajuda" no canto inferior
          dessa página {'>'} busque "cancelar a assinatura" {'>'} clique no ícone 👎 para abrir seu
          chamado.
        </p>
      </div>
    </>
  );
};

export const RecurrenceDisableConfirmation = ({
  date,
  collection,
  updateTypeCb,
  nextStepCb,
  prevStepCb,
}) => {
  
  let nextRecurrenceDate = GetEditionDateName(date, false, '/');
// mensagem de confirmação
  return (
    <>
      <p className={'text-center'}>
        Tem certeza de que deseja desativar a sua renovação? Lembre-se que deixará de ser uma
        Glamgirl em {nextRecurrenceDate}. Caso mude de ideia, reative a renovação antes dessa data!
        Antes, só nos conte qual o motivo da sua decisão:
      </p>

      {ControlRenderer.renderCollection(collection)}
    </>

  );
};

export const RecurrenceDisableMonthly = ({ date }) => { 
  let nextRecurrenceDate = GetEditionDateName(date, false, '/');

  return (
    <>
      <h3 className={'text-center mb-2'}>
        <span aria-label="sirene" role="img">
          🚨
        </span>
        Atenção Glamgirl
        <span aria-label="sirene" role="img">
          🚨
        </span>
      </h3>

      <div className={Styles['alert']}>
        <p className={'text-center'}>
          Ao desabilitar sua recorrência, você não poderá assinar o plano mensal pelos próximos 6
          meses. Que tal se tornar uma Glamgirl por mais tempo com R$100 OFF? Utilize o cupom
          AMOGLAM e de <s>R$67,90/mês</s>, pague R$59,57/mês!
        </p>
      </div>
    </>
  );
};
class Recurrence extends Component {
  state = {
    current: 0,
    min: null,
    max: null,
    questions: null,
  };

  collection = null;

  constructor(props) {
    super(props);

    this.state = {
      current: 0,
      min: props.isActive ? RECURRENCE_DISABLE_MIN : RECURRENCE_ENABLE_MIN,
      max: props.isActive ? RECURRENCE_DISABLE_MAX : RECURRENCE_ENABLE_MAX,
    };
  }

  componentDidMount() {
    const { isActive, token } = this.props;

    if (isActive) {
      this.collection = new CtrlCollection();
      for (let control of RecurrenceDisableForm) {
        this.collection.add(control);
      }

      RecurrenceDisableTypeRequest(
        token,
        (result) => {
          this.setState(
            {
              questions: result,
            },
            () => {
              let dropDown = this.collection.get('type'),
                options = [];

              for (let n in result) {
                options.push({
                  name: result[n].creditCardRecurrenceLogTypeName,
                  value: result[n].creditCardRecurrenceLogTypeId,
                });
              }

              dropDown.options = options;

              this.forceUpdate();
            }
          );
        },
        (res) => {
          console.error(res);
        }
      );
    }
  }

  actionCancel = () => {
    this.props.onFinish(this.props.isActive);
  };

  returnDisable = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    this.setState({
      current: Math.max(this.state.min, this.state.current - 1),
    });

    console.log(e.target);
  };

  returnEnable = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    this.setState({
      current: Math.max(this.state.min, this.state.current - 1),
    });

    console.log(e.target);
  };

  proceedDisable = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    let goNext = () => {
      this.setState({
        current: Math.min(this.state.max, this.state.current + 1),
      });
    };

    switch (this.state.current) {
      case 1:
        goNext();
        break;
      case 2:
        break;
      case 0:
        goNext();
        break;
    }
  };

  proceedEnable = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    this.setState({
      current: this.state.current + 1,
    });

    console.log(e.target);
  };

  executeDisable = (e) => {
    const { subscriber } = this.props;
    if (e && e.preventDefault) e.preventDefault();

    if (this.collection.validate()) {
      const { person, subscriber, token } = this.props;

      let collectionData = this.collection.toObject(),
        disableRecurrenceObject = {
          subscriberId: subscriber.subscriberId,
          isAdmin: false,
          username: person.person.firstName + ' ' + person.person.lastName,
          typeId: collectionData.type,
          message: collectionData.message,
        };
      RecurrenceDisableRequest(
        disableRecurrenceObject,
        token,
        (res) => {
          this.props.onFinish(false);
          this.props.successAlert(res);
        },
        (res) => {
          this.props.onFinish(this.props.isActive);
          this.props.errorAlert(res);
        }
      );
    } else {
      if (subscriber.subscriptionTypeId !== 1) {
        this.setState({ current: this.state.current - 1 });
      }
      this.forceUpdate();
    }
  };

  executeEnable = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const { person, subscriber, token } = this.props;

    RecurrenceEnableRequest(
      subscriber.subscriberId,
      token,
      (res) => {
        this.props.onFinish(true);
        this.props.successAlert(res);
      },
      (res) => {
        this.props.onFinish(this.props.isActive);
        this.props.errorAlert(res);
      }
    );
  };

  renderStepsDisable = () => {
    const { subscriber } = this.props;

    if (subscriber.subscriptionTypeId === 1) {
      switch (this.state.current) {
        case 1:
          return (
            <RecurrenceDisableConfirmation
              date={subscriber.lastEdition}
              collection={this.collection}
            />
          );
        default: return <RecurrenceDisableMonthly date={subscriber.lastEdition} />;
      }
    } else {
      switch (this.state.current) {
        case 1:
          return (
            <RecurrenceDisableConfirmation
              date={subscriber.endEdition}
              collection={this.collection}
            />
          );
        default: return <RecurrenceDisable date={subscriber.endEdition} />;
        case 2:
          return <RecurrenceSacInfo date={subscriber.endEdition} />; 

      }
    }
  };

  renderStepsEnable = () => {
    return <RecurrenceEnable />;
  };

  renderStepsNavigationMonthly = () => {
    let navi = [];

    if (this.state.current > this.state.min) {
      navi.push(
        <button key={'back'} className={'btn btn-light-lime'} onClick={this.actionCancel}>
          NÃO
        </button>
      );
    } else {
      navi.push(
        <button key={'back'} className={'btn btn-light-lime'} onClick={this.props.onChangePlan}>
          QUERO ANUAL
        </button>
      );
    }

    if (this.state.current === 0) {
      navi.push(
        <button key={'next'} onClick={this.proceedDisable} className={'btn btn-light-pink'}>
          não quero
        </button>
      );
    } else {
      navi.push(
        <button key={'next'} onClick={this.executeDisable} className={'btn btn-light-pink'}>
          Sim, desativar
        </button>
      );
    }

    return (
      <div className={Styles['navi']}>
        <nav className={Styles['navigation']}>{navi}</nav>
      </div>
    );
  };

  renderStepsNavigation = () => {
    let navi = [];

    if (this.state.current > this.state.min) {
      if (this.props.isActive) {
        navi.push(
          <button key={'back'} className={'btn btn-light-lime'} onClick={this.returnDisable}>
            Não, voltar
          </button>
        );
      } else {
        navi.push(
          <button key={'back'} className={'btn btn-light-pink'} onClick={this.returnEnable}>
            Não, cancelar
          </button>
        );
      }
    } else {
      if (this.props.isActive) {
        navi.push(
          <button key={'back'} className={'btn btn-light-lime'} onClick={this.actionCancel}>
            Manter meus benefícios!
          </button>
        );
      } else {
        navi.push(
          <button key={'back'} className={'btn btn-light-pink'} onClick={this.actionCancel}>
            Não, retornar
          </button>
        );
      }
    }

    if (this.state.current < 1) {
      if (this.props.isActive) {
        navi.push(
          <button key={'next'} onClick={this.proceedDisable} className={'btn btn-light-pink'}>
            Quero Desativar
          </button>
        );
      } else {
        navi.push(
          <button key={'next'} onClick={this.proceedEnable} className={'btn btn-light-lime'}>
            Sim, prosseguir
          </button>
        );
      }
    } else {
      if (this.props.isActive) {
        navi.push(
          <button key={'next'} onClick={this.proceedDisable} className={'btn btn-light-pink'}>
            Sim, desativar
          </button>
        );
      } else {
        navi.push(
          <button key={'next'} onClick={this.executeEnable} className={'btn btn-light-lime'}>
            Sim, reativar
          </button>
        );
      }
    }

    return (
      <div className={Styles['navi']}>
        {(() => {
          if (this.props.isActive) {
            return <p>Gostaria de prosseguir com a solicitação?</p>;
          }
        })()}
        <nav className={Styles['navigation']}>{navi}</nav>
      </div>
    );
  };

  render() {
    const { isActive, recurrenceInfo, subscriber } = this.props;

    if (!recurrenceInfo && isActive) return null;

    if (isActive === true) {
      if (subscriber.subscriptionTypeId === 1) {
        return (
          <>
            {this.renderStepsDisable()}
            {this.renderStepsNavigationMonthly()}
          </>
        );
      } else {
        return (
          <>
            {this.renderStepsDisable()}
            {this.state.current < 2 ? (
              this.renderStepsNavigation()
            ) : (
              <div className={Styles['btn-center']}>
                <button
                  key={'next'}
                  className={`btn btn-light-lime btn-center`}
                  onClick={this.executeDisable}
                >
                  OK
                </button>
              </div>
            )}
          </>
        );
      }
    }

    return (
      <>
        {this.renderStepsEnable()}
        {this.renderStepsNavigation()}
      </>
    );
  }
}

Recurrence.propTypes = {
  token: PropTypes.string,
  isActive: PropTypes.bool,
  person: PropTypes.any,
  subscriber: PropTypes.any,
  recurrenceInfo: PropTypes.any,
  onFinish: PropTypes.func,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message));
    },
    errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message));
    },
  };
};

Recurrence = connect(mapStateToProps, mapDispatchToProps)(Recurrence);

export { Recurrence };
